// Custom helper functions
export const typeStore = (store)=>{
    if (store == 1) {
        return "Admin"
    }else if (store == 2) {
        return "Central Circle"
    }else if (store == 3) {
        return "East Circle"
    }else if (store == 4) {
        return "West Circle"
    }else if (store == 9) {
        return "Technical Emergency"
    }else{
        return " "
    }
}